module.exports = __webpack_public_path__ + "img/background-todos.0894f939.png";